import axios from 'axios'

export default{
    namespaced: true,
    
    state: { 
        attendanceDates: [],
    },

    getters: {
        getAllowedDates(state){
            return state.attendanceDates
        },

        getAttendanceDates(state){
            return state.attendanceDates
        }
    },

    mutations: {
        setAttendanceDates(state, dates){
            state.attendanceDates = dates
        }
    },

    actions: {
        getEmployees(){
            const url = 'api/employee-attendance/employee-records';
            return axios.get(url) 
        },

        getAllowedDates({ rootGetters}){
            const staffType = rootGetters['auth/getEmployeeRecord'].staff_type;
            const url = 'api/employee-attendance/valid-dates';
            return axios.get(url, { params: { staff_type: staffType } })
        },

        getAttendanceData({ getters, rootGetters }){
            const staffType = rootGetters['auth/getEmployeeRecord'].staff_type;
            const url = '/api/employee-attendance'
            return axios.get(url, {
                params: {
                    employee_id: rootGetters['auth/getEmployeeId'],
                    start_date: getters.getAttendanceDates[0],
                    end_date: getters.getAttendanceDates[1],
                    staff_type: staffType
                }
            })
        }
    }
}